"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ScreenPlaceholder = require("../../molecules/ScreenPlaceholder");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ChatPlaceholderNotAvailable = function ChatPlaceholderNotAvailable() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenPlaceholder.ScreenPlaceholder, {
    title: "Esse chat n\xE3o est\xE1 mais dispon\xEDvel"
  });
};
var _default = exports["default"] = ChatPlaceholderNotAvailable;